import React from 'react';
import { X, Cookie } from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation';

interface CookiePolicyProps {
  onAccept: () => void;
  onReject: () => void;
}

const CookiePolicy: React.FC<CookiePolicyProps> = ({ onAccept, onReject }) => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 relative"
      style={{ position: 'absolute', top: '20px' }}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div className="flex items-center space-x-2">
            <Cookie className="h-6 w-6 text-amber-500" />
            <h2 className="text-xl font-bold text-gray-800">
              {t('cookiePolicy.title')}
            </h2>
          </div>
          <button
            onClick={onReject}
            className="p-1 hover:bg-gray-100 rounded-full transition-colors"
            aria-label="Close"
          >
            <X className="h-5 w-5 text-gray-500" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <p className="text-gray-600 mb-4 leading-relaxed">
            {t('cookiePolicy.message')}
          </p>
          
          {/* Link alla policy dei cookie */}
          <div className="mb-6">
            <a
              href="/cookie-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-pink-500 hover:text-pink-600 underline text-sm"
            >
              {t('cookiePolicy.policyLinkText')}
            </a>
          </div>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={onAccept}
              className="flex-1 bg-pink-500 hover:bg-pink-600 text-white font-semibold py-3 px-4 rounded-lg transition-colors duration-200"
              aria-label={t('cookiePolicy.acceptButton')}
            >
              {t('cookiePolicy.acceptButton')}
            </button>
            <button
              onClick={onReject}
              className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-3 px-4 rounded-lg transition-colors duration-200"
              aria-label={t('cookiePolicy.rejectButton')}
            >
              {t('cookiePolicy.rejectButton')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;